<template>
  <div>
    <AboutBanner :imageList="this.config.banner_top.imageList"></AboutBanner>
    <Title></Title>
    <AboutOverview></AboutOverview>
    <AboutShopping></AboutShopping>
    <AboutShoppingList></AboutShoppingList>
    <Target></Target>
    <MileStore></MileStore>
    <!-- <FutureRecords></FutureRecords> -->
    <FutureGoals></FutureGoals>
    <AboutBanner3></AboutBanner3>
  </div>
</template>

<script>
import AboutBanner from "@/yintai/view/content/about/AboutBanner.vue";
import AboutOverview from "@/yintai/view/content/about/AboutOverview.vue";
import Title from "@/yintai/view/content/about/Title.vue";
import Target from "@/yintai/view/content/about/Target.vue";
import AboutShopping from "@/yintai/view/content/about/AboutShopping.vue";
import AboutShoppingList from "@/yintai/view/content/about/AboutShoppingList.vue";

import MileStore from "@/yintai/view/content/event/MileStore.vue";
// import FutureRecords from "@/yintai/view/content/event/FutureRecords.vue";
import FutureGoals from "@/yintai/view/content/event/FutureGoals.vue";

import AboutBanner3 from "@/yintai/view/content/about/AboutBanner3.vue";
import { fetchConfig } from "@/yintai/api/config";

export default {
  name: "about",
  components: {
    AboutBanner,
    AboutOverview,
    AboutShopping,
    AboutShoppingList,
    Title,
    Target,
    MileStore,
    // FutureRecords,
    FutureGoals,
    AboutBanner3,
  },
  data() {
    return {
      config: {
        banner_top: {
          imageList: [],
        },
      },
    };
  },
  async mounted() {
    const response = await fetchConfig({ id: 4 });
    this.config = response.data.data.item.config;
  },
  methods: {},
};
</script>
